<template>
  <div class="modular w-full">
    <div
      v-if="chart.length"
      class="show-modular flex items-end w-full"
    >
      <div class="height-breakthrough flex justify-between items-end w-full">
        <div
          v-for="(b, index) in chart"
          :key="index"
          :style="[{ width: b.width + '%' }, { 'min-width': '1px' }, { height: (b.height / 100) * 28 + 'px' }]"
          class="bar-window"
        >
          <div
            class="bar h-full"
            :style="[{ background: barColor(b.widthFill) }]"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  chart: {
    type: Array,
    default: () => {
      return [];
    }
  }
});
const barColor = (value) => {
  return `linear-gradient(to right, #4D97FF ${value}%,rgba(255,255,255,0.2) ${value}%)`;
};
</script>

<style lang="scss" scoped>
.modular {
  .show-modular {
    .height-breakthrough {
      height: 28px;
      .bar-window {
        box-sizing: border-box;
        padding-right: 0.5px;
        &:last-child {
          padding-right: 0;
        }
        .bar {
          border-radius: 1px 1px 0 0;
        }
      }
    }
  }
}
</style>
